import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ItemServicoDetalheJanelaComponent } from './item-servico-detalhe-janela.component';

@NgModule({
  imports: [RouterModule.forChild([
    {path: ':id', component: ItemServicoDetalheJanelaComponent}
  ])],
  exports: [RouterModule]
})
export class ItemServicoDetalheJanelaRoutingModule { }
